export default __webpack_public_path__ + "d27976e740c80d37ab0da2d199a2eba7.png";